import React from 'react'
import ReactMarkdown, { Components } from 'react-markdown'

interface IProps {
  children: string
  components?: Components
}

export type MarkdownComponents = Components

// Out of every text, whoever wrote it. An image would have each reader's browser call a
// host the writer chose, which then sees who reads the page and when; images come from
// the media library, through a field of their own.
export const DISALLOWED_ELEMENTS = ['img']

// The only place that turns markdown into elements (ESLint keeps react-markdown out of
// every other file), so what a writer can make a reader's browser do is decided once:
// no images, no HTML (react-markdown shows it as the text it is, so never add rehype-raw)
// and links only to web, mail and phone addresses, which is its default.
const Markdown: React.FC<IProps> = ({ children, components }) => (
  <ReactMarkdown
    children={children}
    components={components}
    disallowedElements={DISALLOWED_ELEMENTS}
  />
)

export default Markdown
